import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../layout/Layout'
import secureApi from '../helpers/secureApi';
import { storeData } from '../redux/store';

export default function Login() {

    const store = useSelector((state: storeData)=> state?.common);
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [btnDisabled, setBtnDisabled] = useState(false);

    const loginUser = (e: React.FormEvent)=>{
        e.preventDefault();
        if(email && password){
            setBtnDisabled(true);
            axios.post(secureApi("login"), {
                email: email,
                password: password
            })
            .then(response=>{
                setBtnDisabled(false);
                console.log("response", response);
                if(response?.data){
                    if(response?.data?.type=='error'){
                        
                    }
                    else if(response?.data?.type=='success'){
                        if(response?.data?.user?.token){
                            localStorage.setItem('user', (response?.data?.user?.token));
                            navigate('/');
                        }
                    }
                }
            })
            .catch(error=>{
                console.log("error", error);
                setBtnDisabled(false);
            })
        }
        else{
            console.log("email & password is required")
        }
    }

    useEffect(()=>{
        //console.log("store", store)
        if(store?.user){
            navigate('/');
        }
    }, [store]);

  return (
    <Layout>
        <div className='formWrap'>
            <div><h1>Login</h1></div>
            <form onSubmit={loginUser}>
                <input type="text" placeholder='Email' onChange={(e:React.ChangeEvent<HTMLInputElement>)=>setEmail(e.target.value)} />
                <input type="password" placeholder='Password' onChange={(e:React.ChangeEvent<HTMLInputElement>)=>setPassword(e.target.value)} />
                <button type='submit' disabled={btnDisabled}>Save</button>
            </form>
        </div>
    </Layout>
  )
}
